import React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { IconProps } from '..'

const CalenderOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <G clipPath="url(#clip0_46_2166)">
        <Path
          d="M8.0584 10.075H5.85006C5.50949 10.075 5.2334 10.3511 5.2334 10.6917V12.65C5.2334 12.9906 5.50949 13.2667 5.85006 13.2667H8.0584C8.39897 13.2667 8.67506 12.9906 8.67506 12.65V10.6917C8.67506 10.3511 8.39897 10.075 8.0584 10.075Z"
          fill={color}
        />
        <Path
          d="M15.0084 4.33333H14.0001V3.15833C14.0001 2.79167 13.7001 2.49167 13.3334 2.49167C12.9667 2.49167 12.6667 2.79167 12.6667 3.15833V4.33333H7.33339V3.15833C7.33339 2.79167 7.03339 2.49167 6.66672 2.49167C6.30006 2.49167 6.00006 2.79167 6.00006 3.15833V4.33333H5.00839C3.63339 4.33333 2.51672 5.45 2.51672 6.825V15.075C2.51672 16.45 3.63339 17.5667 5.00839 17.5667H15.0084C16.3834 17.5667 17.5001 16.45 17.5001 15.075V6.825C17.5001 5.45 16.3834 4.33333 15.0084 4.33333ZM16.1667 15.075C16.1667 15.7167 15.6501 16.2333 15.0084 16.2333H5.00839C4.36672 16.2333 3.85006 15.7167 3.85006 15.075V9H16.1667V15.075ZM16.1667 7.66667H3.85006V6.825C3.85006 6.18333 4.36672 5.66667 5.00839 5.66667H15.0084C15.6501 5.66667 16.1667 6.18333 16.1667 6.825V7.66667Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_46_2166">
          <Rect width="20" height="20" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default CalenderOutlined
